import { Link } from 'react-router-dom';
import { useLang } from '../../lib/lang';
import { PAGE_KEYS } from '../../content/routes';
import { CONTACT, ADDRESS_LABELS } from '../../content/constants';

export default function Footer() {
  const { t, lang, link } = useLang();
  const f = t.footer;
  const al = ADDRESS_LABELS[lang] || ADDRESS_LABELS.pt;
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-obsidian relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-10">
        <div className="grid md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <img
              src="/brand/eds-angola-logo.png"
              alt="EDS Angola — Engineering & Data Solutions"
              data-testid="footer-logo"
              className="w-auto h-40 md:h-48 -ml-2"
            />
            <p className="mt-4 text-sm text-zinc-400 leading-relaxed max-w-sm">{f.tagline}</p>
            <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-volt">{f.vertiv}</p>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">{f.navTitle}</p>
            <ul className="mt-5 space-y-2.5">
              {PAGE_KEYS.map((k) => (
                <li key={k}>
                  <Link
                    to={link(k)}
                    data-testid={`footer-link-${k}`}
                    className="text-sm text-zinc-400 hover:text-volt transition-colors duration-300"
                  >
                    {t.nav[k]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">{f.contactTitle}</p>
            <address className="mt-5 not-italic text-sm text-zinc-400 leading-relaxed">
              <p className="text-base md:text-lg text-white font-semibold">{CONTACT.company}</p>
              <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-volt">{al.hq}</p>
              <p className="mt-1.5 font-display text-lg md:text-xl font-bold text-white leading-snug">{CONTACT.hq.line1}</p>
              <p className="text-base text-zinc-300 leading-snug">{CONTACT.hq.line2}</p>
              <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">{al.tech}</p>
              <p className="mt-1 text-sm">{CONTACT.tech}</p>
              <p className="mt-3">
                <a data-testid="footer-phone" href={`tel:${CONTACT.phoneHref}`} className="hover:text-volt transition-colors duration-300">{CONTACT.phone}</a>
                {' · '}
                <a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="hover:text-volt transition-colors duration-300">{CONTACT.email}</a>
              </p>
              <p className="mt-2 font-mono text-xs text-zinc-500">NIF: {CONTACT.nif}</p>
            </address>
            <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">{f.groupTitle}</p>
            <div className="mt-4 space-y-2.5">
              {f.groupOffices.map((o) => (
                <div key={o.country}>
                  <p className="font-mono text-[11px] font-bold uppercase tracking-[0.12em] text-zinc-400">{o.country} <span className="text-zinc-600 font-normal normal-case tracking-normal">— {o.name}</span></p>
                  <p className="font-mono text-[11px] text-zinc-500 mt-0.5">{o.detail}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-600">
            © {new Date().getFullYear()} {CONTACT.company} — {f.rights}
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-600">Luanda · Beirut · Baghdad · Lagos</p>
        </div>
      </div>
      <p aria-hidden="true" className="pointer-events-none select-none font-display font-black uppercase text-outline text-[22vw] leading-none absolute -bottom-[7vw] left-0 right-0 text-center opacity-60">
        EDS
      </p>
    </footer>
  );
}
